
import React from "react";
import { FormContext, FormProvider } from 'core/FormProvider';
import {AsyncAutocompleteWidget} from "form/AutocompleteWidget";
import FormGroup from 'form/FormGroup';
import {ContextFormControlWidget} from "form/Contexed";
import {DateWidget} from "form/new/DateWidget";
import {Grid} from "ui/Grid";
import {DateTimeWidget} from "form/new/DateTimeWidget";
import {DatetimeActions} from "form/DatetimeActions";
import moment from "moment";
import Button from "@material-ui/core/Button";
import {YellowButton} from "ui/Button";


export default function OrderMassChangeForm({listContext, loading, onSave}) {

  return (
    <FormProvider
      url={'/'}
      item={{}}
    >
      <FormContext.Consumer>
      {context => {
        const { item } = context;
        return (
          <FormGroup style={{maxWidth: '600px'}}>
            <ContextFormControlWidget
              name={'order_status'}
              WidgetComponent={AsyncAutocompleteWidget}
              widgetProps={{
                url: 'catalog/order_status',
                label: 'Статус перевозки',
                optionLabel: 'label'
              }}
            />

            <ContextFormControlWidget
              name={'order_type'}
              WidgetComponent={AsyncAutocompleteWidget}
              widgetProps={{
                label: 'Тип перевозки',
                url: 'catalog/choice',
                optionLabel: 'name',
                filter: {
                  type: 'ORDER_TYPE'
                }
              }}
            />

            <Grid columns={'1fr 1fr'} mobileColumns={'1fr'}>
              <DateWidget
                value={item.station_arrival_date}
                label={'Дата прихода на станцию'}
                onChange={(value, stringValue) => context.setDateValue('station_arrival_date', value)}
              />
              <DateWidget
                value={item.station_arrival_notify_date}
                label={'Дата уведомления'}
                onChange={(value, stringValue) => context.setDateValue('station_arrival_notify_date', value)}
              />
            </Grid>

            <ContextFormControlWidget
              name={'date_start'}
            >
              <DateTimeWidget
                value={item.date_start}
                label={'Дата начала перевозки'}
                onChange={(value, stringValue) => context.setDateTimeValue('date_start', value)}
              />
              <DatetimeActions
                value={item.date_start}
                onChange={(value) => context.setDateTimeValue('date_start', value)}
                className={'mt-5'}
              />
            </ContextFormControlWidget>

            <ContextFormControlWidget
              name={'date_end'}
            >
              <DateTimeWidget
                value={item.date_end}
                minDate={item.date_start}
                label={'Дата завершения перевозки'}
                openToDate={item.date_start ? moment(item.date_start).toDate() : undefined}
                onChange={(value, stringValue) => context.setDateTimeValue('date_end', value)}
              />
              <DatetimeActions
                value={item.date_end}
                onChange={(value) => context.setDateTimeValue('date_end', value)}
                className={'mt-5'}
              >
                {item.date_start && (
                  <Button
                    onClick={() => context.setDateTimeValue('date_end', moment(item.date_start).endOf('day'))}>
                    {moment(item.date_start).format('DD.MM')}
                  </Button>
                )}
              </DatetimeActions>
            </ContextFormControlWidget>

            <div>
              <YellowButton onClick={() => onSave(context)} disabled={loading}>
                Изменить перевозки ({listContext.getSelectedItems().length})
              </YellowButton>
            </div>
          </FormGroup>
        )
      }}
      </FormContext.Consumer>
    </FormProvider>
  )
}